<risr-async [wrapper]="reportReady">
    @if (reportReady.value()) {
        <risr-features-reports-report-result></risr-features-reports-report-result>

        @if (canNavigateTo()) {
            @let username = this.username();
            @if (username === '__own__') {
                <a mat-stroked-button [routerLink]="['/reports/run', reportId()]" i18n>View more</a>
            } @else {
                <a mat-stroked-button [routerLink]="['/users', 'edit', username, 'reports', 'run', reportId()]" i18n>View more</a>
            }
        }

    }
</risr-async>